import { render, staticRenderFns } from "./ModalNewEconomicGroup.vue?vue&type=template&id=3a6d3c20"
import script from "./ModalNewEconomicGroup.vue?vue&type=script&lang=js"
export * from "./ModalNewEconomicGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports